import {isNil} from 'ramda';

const OWNER_COLOR_PATTERN = /^#[\da-f]{6}$/i;

function getOwnerColorRgb(ownerColor: string | null): readonly [number, number, number] | null {
  if (isNil(ownerColor) || OWNER_COLOR_PATTERN.test(ownerColor) === false) {
    return null;
  }

  return [
    Number.parseInt(ownerColor.slice(1, 3), 16),
    Number.parseInt(ownerColor.slice(3, 5), 16),
    Number.parseInt(ownerColor.slice(5, 7), 16),
  ] as const;
}

/**
 * Creates a decorative, repeating owner tint as a percent-encoded SVG data URI.
 * The incoming Google palette value is strictly validated and converted to RGB numbers before
 * it is inserted into the SVG, so arbitrary input cannot become SVG markup or a CSS declaration.
 */
export function repeatingGradient(ownerColor: string | null): string | null {
  const ownerColorRgb = getOwnerColorRgb(ownerColor);

  if (isNil(ownerColorRgb)) {
    return null;
  }

  const rgbColor = `rgb(${ownerColorRgb[0]}, ${ownerColorRgb[1]}, ${ownerColorRgb[2]})`;
  const svg = [
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">',
    '<defs><pattern id="owner-gradient" width="20" height="20" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">',
    `<rect width="20" height="10" fill="${rgbColor}" fill-opacity="0.125"/>`,
    `<rect y="10" width="20" height="10" fill="${rgbColor}" fill-opacity="0.25"/>`,
    '</pattern></defs><rect width="100%" height="100%" fill="url(#owner-gradient)"/></svg>',
  ].join('');

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
